// @core/api/endpoints/payment/refund_payment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RefundPaymentRequest,
  RefundPaymentResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Refund payment
 * Issues a full or partial refund for a captured payment. Refund is sent to the same provider that processed the original payment.
 */
export async function RefundPayment(
  id: string,
  data: RefundPaymentRequest,
  options?: RequestOptions
): Promise<RefundPaymentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payments/:id/refund`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<RefundPaymentResponse>(requestPath, data, requestOptions);
}
